import base from "../base";
import resortBase from "../base/resort";
import logo from "./logo.svg";
import backgroundImage from "./background.jpg";
import favicon16 from "./favicon-16x16.png";
import favicon32 from "./favicon-16x16.png";
import favicon96 from "./favicon-16x16.png";
import { BrandInterface } from "../interface";

const palisadesTahoe = {
  ...base,
  ...resortBase,
  title: "Palisades Tahoe",
  logo,
  backgroundImage,
  resortURL: "https://www.palisadestahoe.com/",
  favicons: {
    "16x16": favicon16,
    "32x32": favicon32,
    "96x96": favicon96,
  },
  color: {
    ...base.color,
    ...resortBase.color,
    footer: "#201547",
    footerText: "#ffffff",
    button: "#FF5E00",
    buttonHover: "#201547",
    link: "#201547",
    linkHover: "#1A1139",
  },
} as BrandInterface;

export default palisadesTahoe;
